import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { JsonDetails } from '../../../app/models/jsonDetails.model';

@Injectable({
  providedIn: 'root',
})
export class TranslatingDataService {
  constructor(
    private http: HttpClient,
    @Inject(LOCALE_ID) private language: string
  ) {
    //this.translatedData = this.retrieveTranslatedData();
  }
  // private translatedData: Observable<JsonDetails> = null;

  private translatedData: JsonDetails;
  private loaded: boolean;
  public getTranlateddata(): JsonDetails {
    return this.translatedData;
  }

  public retrieveTranslatedData() {
    let rt: Promise<any>;
    if (!this.loaded) {
      let language = this.getLanguage();
      const jsonData = this.http
        .get<any>('assets/jsons/' + 'list-' + language + '.json')
        .toPromise();
      jsonData
        .then((data) => {
          this.translatedData = data;
          this.loaded = true;
        })
        .catch((error) => {
          console.log(error);
          this.handleError(error);
        });
      rt = jsonData;
    }
    return rt;
  }

  private getLanguage(): string {
    //return window.location.pathname.includes('/ar/') ? 'ar' : 'en';
    return this.language;
  }
  /*
  public getTranlateddata(): Observable<JsonDetails> {
    return this.translatedData;
  }

  private retrieveTranslatedData(): Observable<any> {
    let language = this.getLanguage();

    return this.http
      .get<Observable<any>>('assets/jsons/' + 'list-' + language + '.json')
      .pipe(catchError(this.handleError));
  }*/

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `JSON file not loaded ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError(error);
  }
}
